import { INTL_LOCALES, type Locale, type Message, type PluralForms, type TranslateVars } from './types';

const pluralRulesCache = new Map<Locale, Intl.PluralRules>();

const pluralRules = (locale: Locale): Intl.PluralRules => {
  const cached = pluralRulesCache.get(locale);
  if (cached) return cached;
  const rules = new Intl.PluralRules(INTL_LOCALES[locale]);
  pluralRulesCache.set(locale, rules);
  return rules;
};

const isPlural = (message: Message): message is PluralForms => typeof message !== 'string';

const selectForm = (locale: Locale, forms: PluralForms, count: number): string => {
  const category = pluralRules(locale).select(count);
  if (category === 'one') return forms.one;
  if (category === 'few') return forms.few ?? forms.other;
  if (category === 'many') return forms.many ?? forms.other;
  return forms.other;
};

/** Replaces `{name}` placeholders; an unknown placeholder is left untouched. */
const interpolate = (template: string, vars: TranslateVars | undefined): string => {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in vars ? String(vars[name]) : match,
  );
};

export const formatMessage = (
  locale: Locale,
  message: Message,
  vars?: TranslateVars,
): string => {
  const template =
    isPlural(message) && typeof vars?.count === 'number'
      ? selectForm(locale, message, vars.count)
      : isPlural(message)
        ? message.other
        : message;

  return interpolate(template, vars);
};
